<script lang="ts">
  export let size: 'small' | 'medium' | 'large'
  const fill: string = 'currentColor'
</script>

<svg
  class="svg-{size}"
  viewBox="0 0 24 24"
  fill="none"
  stroke={fill}
  stroke-width="1.5"
  stroke-linecap="round"
  stroke-linejoin="round"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M13 6H8.5C6.01472 6 4 8.01472 4 10.5C4 12.9853 6.01472 15 8.5 15H20" />
  <path d="M17 12C17 12 20 14.2095 20 15C20 15.7906 17 18 17 18" />
</svg>
